import { Grid } from "@mui/material";

import Button from "../../../../../common/button/components/Button";
import { NetworkSelect } from "../NetworkSelect";
import { SelectOption } from "./networkFormTypes";

type NetworkFormFieldsProps = {
  plans: SelectOption[];
  states: SelectOption[];
  cities: SelectOption[];
  districts: SelectOption[];
  occupationArea: SelectOption[];

  planValue: string;
  stateValue: string;
  cityValue: string;
  districtValue: string;
  occupationAreaValue: string;

  isLoading: boolean;
  canSearch: boolean;

  onPlanChange: (plan: string) => void;
  onStateChange: (state: string) => void;
  onCityChange: (city: string) => void;
  onDistrictChange: (district: string) => void;
  onOccupationAreaChange: (occupationArea: string) => void;
};

export const NetworkFormFields = ({
  plans,
  states,
  cities,
  districts,
  occupationArea,
  planValue,
  stateValue,
  cityValue,
  districtValue,
  occupationAreaValue,
  isLoading,
  canSearch,
  onPlanChange,
  onStateChange,
  onCityChange,
  onDistrictChange,
  onOccupationAreaChange,
}: NetworkFormFieldsProps) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 6 }} marginBottom={2}>
          <NetworkSelect
            select={{ options: plans }}
            testId="plan"
            name="plan"
            label="Plano:"
            value={planValue}
            onChange={(event) => onPlanChange(event.target.value)}
            isDisabled={isLoading || !plans.length}
          />
        </Grid>
      <Grid size={{ xs: 12, sm: 6 }} marginBottom={2}>
        <NetworkSelect
          select={{ options: states }}
          testId="state"
          name="state"
          label="Estado:"
          value={stateValue}
          onChange={(event) => onStateChange(event.target.value)}
          isDisabled={isLoading || states.length === 0}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }} marginBottom={2}>
        <NetworkSelect
          select={{ options: cities }}
          testId="cities"
          name="cities"
          label="Selecione a Cidade:"
          value={cityValue}
          onChange={(event) => onCityChange(event.target.value)}
          isDisabled={isLoading || cities.length === 0}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }} marginBottom={2}>
        <NetworkSelect
          select={{ options: districts }}
          testId="districts"
          name="district"
          label="Escolha o Bairro:"
          value={districtValue}
          onChange={(event) => onDistrictChange(event.target.value)}
          isDisabled={isLoading || districts.length === 0}
        />
      </Grid>

      <Grid size={{ xs: 12 }} marginBottom={2}>
        <NetworkSelect
          select={{ options: occupationArea }}
          testId="occupation_area"
          name="occupation_area"
          label="Escolha a área de atuação:"
          value={occupationAreaValue}
          onChange={(event) => onOccupationAreaChange(event.target.value)}
          isDisabled={isLoading || occupationArea.length === 0}
        />
      </Grid>

      <Grid size={{ xs: 12 }} marginTop={2}>
        <Button
          disabled={!canSearch}
          type="submit"
          variant="contained"
          $background="fill"
        >
          {isLoading ? "Carregando dados aguarde..." : "Buscar"}
        </Button>
      </Grid>
    </Grid>
  );
};